<template>
  <v-text-field
    v-model="searchTerm"
    :label="label"
    prepend-inner-icon="mdi-magnify"
    :id="id"
    solo
    hide-details
    clearable
    @keyup="search"
    @click:clear="search"
  ></v-text-field>
</template>

<script>
export default {
  name: 'SearchBox',
  props: {
    label: {
      type: String,
      default: 'Pesquisar'
    },
    id: {
      type: String,
      default: 'searchBox'
    }
  },
  data: () => ({
    searchTerm: '',
    timeout: null
  }),
  methods: {
    search() {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.$emit('search', this.searchTerm);
      }, 500);
    }
  }
}
</script>

<style>

</style>